<template>
  <b-navbar class="custom-survey-main-navbar" variant="white02">
    <b-navbar-nav>
      <b-nav-item
        :active="isActive(0)"
        :disabled="navDisabled"
        class="mr-3"
        @click="changeTab(0)"
      >
        <b-badge pill :variant="getVariant(0)" class="mr-2">
          1
        </b-badge>
        {{ labels.configurations }}
      </b-nav-item>
      <b-nav-item
        v-if="!isTemplate"
        :active="isActive(1)"
        :disabled="navDisabled"
        class="mr-3"
        @click="changeTab(1)"
      >
        <b-badge pill :variant="getVariant(1)" class="mr-2">
          2
        </b-badge>
        {{ labels.surveyInformations }}
      </b-nav-item>
      <b-nav-item
        :active="isActive(2)"
        :disabled="navDisabled"
        @click="changeTab(2)"
      >
        <b-badge pill :variant="getVariant(2)" class="mr-2">
          {{ isTemplate ? 2 : 3 }}
        </b-badge>
        {{ labels.summary }}
      </b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  activeTab: {
    type: Number,
    default: 0,
  },
  navDisabled: {
    type: Boolean,
    default: true,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
      isTemplate: 'customSurveys/isTemplate',
    }),
    labels() {
      return this.resources.component.customSurveys.create.navbars
    },
  },
  methods: {
    isActive(tab) {
      return this.activeTab === tab
    },
    getVariant(tab) {
      return this.isActive(tab) ? 'secondary' : 'white'
    },
    changeTab(tab) {
      this.$emit('changeTab', tab)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/variables';
@import '~@/styles/custom/colors';

.navbar-expand {
  justify-content: center;

  .active {
    color: map-get($theme-colors, 'secondary') !important;
    font-weight: bold;
  }

  .badge-white {
    border: 1px solid var(--gray07) !important;
  }
}
</style>
